<template>
  <div v-if="localProfile">
    <!-- Label -->
    <div class="d-flex items-center gap-4 mb-3">
      <span class="body-2 font-weight-medium">{{ $t('Pilot.QuickControl.NavProfile.NavigationProfil') }} :</span>
      <!-- <v-text-field
        hide-details
        type="text"
        :label="$t('Pilot.QuickControl.NavProfile.Label')"
        v-model="localProfile.prf_label"
        class="shrink"
        style="max-width: 180px"
        @input="emit"
      /> -->
    </div>
    <v-layout row wrap>
      <!-- Colonne formulaire -->
      <v-flex xs6 class="flex flex-col border-r border-gray-300 pr-2">
        <!-- Groupe Ballast -->
        <div class="grey--text text--darken-1 mb-1 font-bold!">Ballast</div>
        <!-- bd : input (1/4) + select unité (3/4) -->
        <div class="flex items-start gap-2">
          <number-field-factor
            style="flex: 1 1 0; min-width: 0"
            hide-details
            :label="$t('Pilot.QuickControl.NavProfile.Bd')"
            :min="fieldMin('bd')"
            :max="fieldMax('bd')"
            :round="true"
            :value="fields.bd.display"
            @input="v => onFieldInput('bd', v)"
            @focusin.native="fields.bd.hintShown = true"
            @focusout.native="fields.bd.hintShown = false"
          />
          <v-select
            hide-details
            dense
            style="flex: 3 1 0; min-width: 0"
            :items="unitItems('bd')"
            :value="fields.bd.unit"
            :label="$t('Pilot.QuickControl.NavProfile.UnitLabel')"
            @input="u => onFieldUnitChange('bd', u)"
          />
        </div>
        <div class="v-messages px-1" style="min-height: 14px">
          <div class="v-messages__wrapper">
            <div class="v-messages__message" v-show="fields.bd.hintShown">
              {{ $t('Pilot.QuickControl.NavProfile.BdTooltip') }}
            </div>
          </div>
        </div>
        <!-- bu : input (1/4) + select unité (3/4) -->
        <div class="flex items-start gap-2">
          <number-field-factor
            style="flex: 1 1 0; min-width: 0"
            hide-details
            :label="$t('Pilot.QuickControl.NavProfile.Bu')"
            :min="fieldMin('bu')"
            :max="fieldMax('bu')"
            :round="true"
            :value="fields.bu.display"
            @input="v => onFieldInput('bu', v)"
            @focusin.native="fields.bu.hintShown = true"
            @focusout.native="fields.bu.hintShown = false"
          />
          <v-select
            hide-details
            dense
            style="flex: 3 1 0; min-width: 0"
            :items="unitItems('bu')"
            :value="fields.bu.unit"
            :label="$t('Pilot.QuickControl.NavProfile.UnitLabel')"
            @input="u => onFieldUnitChange('bu', u)"
          />
        </div>
        <div class="v-messages px-1" style="min-height: 14px">
          <div class="v-messages__wrapper">
            <div class="v-messages__message" v-show="fields.bu.hintShown">
              {{ $t('Pilot.QuickControl.NavProfile.BuTooltip') }}
            </div>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="flex flex-col pl-2">
        <!-- Groupe Pitch -->
        <div class="grey--text text--darken-1 mb-1 font-bold!">Pitch</div>
        <!-- pd : input (1/4) + select unité (3/4) — une seule unité pour l'instant -->
        <div class="flex items-start gap-2">
          <number-field-factor
            style="flex: 1 1 0; min-width: 0"
            hide-details
            :label="$t('Pilot.QuickControl.NavProfile.Pd')"
            :min="fieldMin('pd')"
            :max="fieldMax('pd')"
            :round="true"
            :value="fields.pd.display"
            @input="v => onFieldInput('pd', v)"
            @focusin.native="fields.pd.hintShown = true"
            @focusout.native="fields.pd.hintShown = false"
          />
          <v-select
            hide-details
            dense
            style="flex: 3 1 0; min-width: 0"
            :items="unitItems('pd')"
            :value="fields.pd.unit"
            :label="$t('Pilot.QuickControl.NavProfile.UnitLabel')"
            @input="u => onFieldUnitChange('pd', u)"
          />
        </div>
        <div class="v-messages px-1" style="min-height: 14px">
          <div class="v-messages__wrapper">
            <div class="v-messages__message" v-show="fields.pd.hintShown">
              {{ $t('Pilot.QuickControl.NavProfile.PdTooltip') }}
            </div>
          </div>
        </div>
        <!-- pu : input (1/4) + select unité (3/4) — une seule unité pour l'instant -->
        <div class="flex items-start gap-2">
          <number-field-factor
            style="flex: 1 1 0; min-width: 0"
            hide-details
            :label="$t('Pilot.QuickControl.NavProfile.Pu')"
            :min="fieldMin('pu')"
            :max="fieldMax('pu')"
            :round="true"
            :value="fields.pu.display"
            @input="v => onFieldInput('pu', v)"
            @focusin.native="fields.pu.hintShown = true"
            @focusout.native="fields.pu.hintShown = false"
          />
          <v-select
            hide-details
            dense
            style="flex: 3 1 0; min-width: 0"
            :items="unitItems('pu')"
            :value="fields.pu.unit"
            :label="$t('Pilot.QuickControl.NavProfile.UnitLabel')"
            @input="u => onFieldUnitChange('pu', u)"
          />
        </div>
        <div class="v-messages px-1" style="min-height: 14px">
          <div class="v-messages__wrapper">
            <div class="v-messages__message" v-show="fields.pu.hintShown">
              {{ $t('Pilot.QuickControl.NavProfile.PuTooltip') }}
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <!-- Ligne : surfacing rate + altitude -->
    <v-layout row wrap>
      <v-flex xs6 class="flex flex-col pr-2">
        <!-- v-text-field (et non number-field-factor) : émet `input` à chaque
             frappe → schéma redessiné instantanément, parité Zs/Zt/Zb (le
             number-field-factor n'émet qu'au @change/blur). -->
        <v-text-field
          type="number"
          min="1"
          :label="$t('Pilot.QuickControl.NavProfile.Sr')"
          :hint="$t('Pilot.QuickControl.NavProfile.SrTooltip')"
          v-model.number="localProfile.sr"
          @input="emit"
          @blur="onSrBlur"
        />
      </v-flex>
      <v-flex xs6 class="flex flex-col pl-2">
        <number-field-factor
          :label="$t('Pilot.QuickControl.NavProfile.Alt')"
          :hint="$t('Pilot.QuickControl.NavProfile.AltTooltip')"
          v-model.number="localProfile.alt"
          @input="emit"
        />
      </v-flex>
    </v-layout>
    <!-- 2 colonnes : formulaire | schéma SVG -->
    <v-layout row wrap>
      <!-- Colonne schéma SVG -->
      <v-flex xs9 class="pl-2 flex flex-col">
        <svg ref="svgEl" :viewBox="`0 0 ${svgW} ${svgH}`" width="100%" style="display: block; max-height: 285px">
          <defs>
            <linearGradient id="qcnp-sea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#E8F4FE" />
              <stop offset="1" stop-color="#ffffff" />
            </linearGradient>
          </defs>

          <!-- Teinte mer sous la surface -->
          <rect :x="svgPadL" :y="yTop" :width="svgInnerW" :height="yBottom - yTop" fill="url(#qcnp-sea)" />

          <!-- Surface de la mer en vagues (y=0) -->
          <path :d="wavePath" fill="none" stroke="#42A5F5" stroke-width="1.4" />

          <!-- Tracé yo : pointillé noir, démarre et finit à 0 (surface) -->
          <polyline
            :points="yoPoints"
            fill="none"
            stroke="#1a1a1a"
            stroke-width="0.6"
            stroke-dasharray="1.2 1.8"
            stroke-linejoin="round"
          />

          <!-- Glider SeaExplorer posé sur la 1re descente, orienté suivant la pente -->
          <image :href="gliderSrc" :width="gliderW" :height="gliderH" :transform="gliderTransform" />

          <!-- Cotations : trait diagonal du sommet vers l'étiquette déportée -->
          <g v-for="m in markers" :key="m.key">
            <line
              :x1="m.vx"
              :y1="m.vy"
              :x2="leaderEndX"
              :y2="m.labelY"
              :stroke="m.color"
              :stroke-width="focusedField === m.key ? 1.3 : 0.7"
            />
            <circle :cx="m.vx" :cy="m.vy" r="1.3" :fill="m.color" />
            <text
              :x="svgW - 2"
              :y="m.labelY + 3"
              font-size="8"
              :fill="m.color"
              text-anchor="end"
              :font-weight="focusedField === m.key ? 'bold' : '600'"
            >
              {{ m.text }}
            </text>
          </g>
        </svg>
      </v-flex>
      <v-flex xs3 class="pl-2 flex flex-col justify-between!">
        <v-text-field
          type="number"
          :label="$t('Pilot.QuickControl.NavProfile.Zs')"
          :hint="$t('Pilot.QuickControl.NavProfile.ZsTooltip')"
          v-model.number="localProfile.zs"
          @input="emit"
          @focus="focusedField = 'zs'"
          @blur="onDepthBlur('zs')"
        />
        <v-text-field
          type="number"
          :label="$t('Pilot.QuickControl.NavProfile.Zt')"
          :hint="$t('Pilot.QuickControl.NavProfile.ZtTooltip')"
          v-model.number="localProfile.zt"
          :disabled="srVal === 1"
          @input="emit"
          @focus="focusedField = 'zt'"
          @blur="onDepthBlur('zt')"
        />
        <v-text-field
          type="number"
          :label="$t('Pilot.QuickControl.NavProfile.Zb')"
          :hint="$t('Pilot.QuickControl.NavProfile.ZbTooltip')"
          v-model.number="localProfile.zb"
          @input="emit"
          @focus="focusedField = 'zb'"
          @blur="onZbBlur"
        />
      </v-flex>
    </v-layout>
  </div>
  <div v-else class="grey--text caption">{{ $t('Pilot.QuickControl.NavProfile.Title') }} —</div>
</template>

<script>
// Consignes du profil nav avec sélecteur d'unité (ballast bu/bd, pitch pd/pu).
// La valeur "wire" envoyée à IRIS encode l'unité par sa plage : wire = offset +
// valeur affichée. offset 0 = valeur brute (volume mL / linear mm) ; ±1000 =
// notation "10XX" (vitesse verticale cm/s, degrés °).
// ⚠ Le signe peut différer selon l'unité (ex. pd : mm positif [0;20] mais
// degrés négatif [-45;0]) — d'où une définition explicite par (champ, unité).
// SeaExplorer : Volume [-500;500] (Shallow [-900;900] plus tard).
// i18n : libellé d'unité via Pilot.QuickControl.NavProfile.Unit<Xxx> (cf UNIT_I18N).
const FIELD_UNITS = {
  bu: [
    { unit: 'volume', min: -500, max: 500, offset: 0 },
    { unit: 'vz', min: 0, max: 40, offset: 1000 },
    { unit: 'vx', min: 5, max: 200, offset: 2000 },
  ],
  bd: [
    { unit: 'volume', min: -500, max: 500, offset: 0 },
    { unit: 'vz', min: -40, max: 0, offset: -1000 },
    // Vitesse horizontale toujours positive (axe X, sens avant) même en descente.
    { unit: 'vx', min: 5, max: 200, offset: 2000 },
  ],
  pd: [
    { unit: 'linear', min: 0, max: 20, offset: 0 },
    { unit: 'degrees', min: -45, max: 0, offset: -1000 },
  ],
  pu: [
    { unit: 'linear', min: -20, max: 0, offset: 0 },
    { unit: 'degrees', min: 0, max: 45, offset: 1000 },
  ],
}

const UNIT_I18N = { volume: 'UnitVolume', vz: 'UnitVz', vx: 'UnitVx', linear: 'UnitLinear', degrees: 'UnitDegrees' }

// Décode la valeur wire IRIS → { unité, valeur affichée } : on teste d'abord les
// unités à offset (plages 10XX) ; à défaut on retombe sur l'unité brute (offset 0).
function decodeField(field, wire) {
  const v = Number(wire) || 0
  for (const u of FIELD_UNITS[field]) {
    if (u.offset === 0) continue
    if (v >= u.offset + u.min && v <= u.offset + u.max) return { unit: u.unit, display: v - u.offset }
  }
  const raw = FIELD_UNITS[field].find(u => u.offset === 0)
  return { unit: raw.unit, display: v }
}

function encodeField(field, unit, display) {
  const u = FIELD_UNITS[field].find(x => x.unit === unit)
  return (u ? u.offset : 0) + display
}

function fieldBounds(field, unit) {
  const u = FIELD_UNITS[field].find(x => x.unit === unit)
  return u ? { min: u.min, max: u.max } : { min: undefined, max: undefined }
}

export default {
  name: 'QuickControlNavProfile',
  props: {
    value: { type: Object, default: null },
  },
  data() {
    return {
      localProfile: null,
      focusedField: null,
      // État de saisie par champ (unité non stockée dans le modèle : déduite de
      // la plage de la valeur via decodeField).
      fields: {
        bu: { unit: 'vz', display: 0, hintShown: false },
        bd: { unit: 'vz', display: 0, hintShown: false },
        pd: { unit: 'linear', display: 0, hintShown: false },
        pu: { unit: 'linear', display: 0, hintShown: false },
      },
      // Largeur viewBox responsive (cf computed svgW) : largeur rendue mesurée.
      measuredW: 200,
      svgRo: null,
      svgH: 140,
      svgPadL: 2,
      svgPadR: 42,
      svgPadT: 10,
      svgPadB: 10,
      // Asset SeaExplorer dédié (rendu couleur 284×103) ≠ glider.png du menu carte.
      // gliderH dérivé de gliderW (computed) pour respecter EXACTEMENT le ratio.
      gliderW: 38,
      gliderSrc: require('@/assets/seaexplorer.png'),
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.localProfile = val ? JSON.parse(JSON.stringify(val)) : null
        this.syncFields()
      },
    },
  },
  mounted() {
    // viewBox responsive : on mesure la largeur rendue et on élargit le viewBox
    // dès que la hauteur naturelle dépasserait le cap 285px, pour remplir la
    // largeur dispo sans letterbox ni distorsion (cf computed svgW).
    if (this.$refs.svgEl && typeof ResizeObserver !== 'undefined') {
      this.svgRo = new ResizeObserver(entries => {
        const w = entries[0]?.contentRect.width
        if (w && w > 0) this.measuredW = w
      })
      this.svgRo.observe(this.$refs.svgEl)
    }
  },
  beforeDestroy() {
    if (this.svgRo) this.svgRo.disconnect()
  },
  computed: {
    // Largeur viewBox : min 200 (échelle du dessin sur panneaux étroits), sinon
    // élargie pour figer la hauteur rendue à 285px tout en occupant 100% large.
    svgW() {
      return Math.max(200, Math.round((this.measuredW * this.svgH) / 285))
    },
    svgInnerW() {
      return this.svgW - this.svgPadL - 50
    },
    svgInnerH() {
      return this.svgH - this.svgPadT - this.svgPadB
    },
    yTop() {
      return this.svgPadT
    },
    yBottom() {
      return this.svgH - this.svgPadB
    },
    zbVal() {
      return Math.abs(this.localProfile?.zb ?? 30)
    },
    zsVal() {
      return Math.abs(this.localProfile?.zs ?? 2)
    },
    altVal() {
      return Math.abs(this.localProfile?.alt ?? 30)
    },
    ztVal() {
      return Math.abs(this.localProfile?.zt ?? 2)
    },
    srVal() {
      return Math.max(1, Math.round(this.localProfile?.sr ?? 1))
    },
    // pixel ratio: maps 0..zbVal to yTop..yBottom
    depthToPx() {
      return depth => {
        const max = this.zbVal || 1
        const ratio = Math.min(depth, max) / max
        return this.yTop + ratio * (this.yBottom - this.yTop)
      }
    },
    yZs() {
      return this.depthToPx(this.zsVal)
    },
    yZt() {
      return this.depthToPx(this.ztVal)
    },
    altPx() {
      const max = this.zbVal || 1
      return (this.altVal / max) * (this.yBottom - this.yTop)
    },
    // Largeur d'un demi-yo (segment descente ou remontée).
    segW() {
      return this.svgInnerW / (this.srVal * 2)
    },
    // Tracé yo : démarre et finit à 0 (surface). Sommets bas = Zb, sommets hauts
    // intermédiaires = Zt ; la dernière remontée revient à 0.
    yoPoints() {
      const sr = this.srVal
      const xStart = this.svgPadL
      const segW = this.segW

      const pts = [[xStart, this.yTop]]
      for (let i = 0; i < sr; i++) {
        const xApex = xStart + (i * 2 + 1) * segW
        const xUp = xStart + (i * 2 + 2) * segW
        const isLast = i === sr - 1
        pts.push([xApex, this.yBottom])
        pts.push([xUp, isLast ? this.yTop : this.yZt])
      }
      return pts.map(p => p.join(',')).join(' ')
    },
    // Surface de la mer dessinée en petites vagues (succession de quarts de
    // sinus via les commandes q/t du path SVG).
    wavePath() {
      const x0 = this.svgPadL
      const y0 = this.yTop
      const xEnd = this.svgPadL + this.svgInnerW
      const step = 10
      const amp = 3
      const n = Math.max(1, Math.round((xEnd - x0) / step))
      let d = `M${x0},${y0} q${step / 2},${-amp} ${step},0`
      for (let i = 1; i < n; i++) d += ` t${step},0`
      return d
    },
    // Angle (deg) de la 1re descente. L'icône SeaExplorer pointe nez vers le
    // bas-gauche ; l'offset constant +199° (calibré empiriquement, cf harness
    // c:/tmp/calib) la fait plonger nez-premier le long du tracé.
    // ⚠ Recalibrer si l'asset change.
    gliderAngle() {
      const theta = (Math.atan2(this.yBottom - this.yTop, this.segW) * 180) / Math.PI
      return theta + 198
    },
    gliderCenter() {
      const t = 0.18 // position le long du 1er segment (proche de la surface)
      return {
        x: this.svgPadL + t * this.segW,
        y: this.yTop + t * (this.yBottom - this.yTop),
      }
    },
    // Hauteur dérivée de la largeur → ratio exact de l'asset (284:103).
    gliderH() {
      return (this.gliderW * 103) / 284
    },
    gliderTransform() {
      const c = this.gliderCenter
      return `translate(${c.x},${c.y}) rotate(${this.gliderAngle}) translate(${-this.gliderW / 2 + 2},${
        -this.gliderH / 2
      })`
    },
    // Abscisse où démarrent les étiquettes (début de la marge droite).
    leaderEndX() {
      return this.svgW - this.svgPadR
    },
    // Cotations : chaque marqueur pointe un sommet précis du yo. Les étiquettes
    // sont déportées dans la marge droite et espacées verticalement pour ne pas
    // se chevaucher (tri par profondeur croissante + écart minimal).
    markers() {
      const xStart = this.svgPadL
      const segW = this.segW
      const sr = this.srVal

      // Zs : point sur la dernière remontée (dernière pointe basse → surface) au
      // niveau de profondeur Zs.
      const lastApexX = xStart + (2 * sr - 1) * segW
      const endX = xStart + this.svgInnerW
      const denom = this.yBottom - this.yTop || 1
      const tZs = (this.yBottom - this.yZs) / denom
      const zsX = lastApexX + tZs * (endX - lastApexX)

      const arr = [{ key: 'zs', color: '#FB8C00', vx: zsX, vy: this.yZs, text: `Zs · ${this.zsVal} m` }]
      if (sr > 1) {
        // Zt : haut du dernier yo intermédiaire (dernière remontée à Zt).
        arr.push({
          key: 'zt',
          color: '#AB47BC',
          vx: xStart + (2 * sr - 2) * segW,
          vy: this.yZt,
          text: `Zt · ${this.ztVal} m`,
        })
      }
      // Zb : dernière pointe basse.
      arr.push({ key: 'zb', color: '#607D8B', vx: lastApexX, vy: this.yBottom, text: `Zb · ${this.zbVal} m` })

      // Anti-chevauchement des étiquettes.
      const gap = 11
      let prev = -Infinity
      for (const m of [...arr].sort((a, b) => a.vy - b.vy)) {
        m.labelY = Math.max(m.vy, prev + gap)
        prev = m.labelY
      }
      return arr
    },
  },
  methods: {
    // Options d'unité d'un champ pour le <v-select> (peut n'en avoir qu'une).
    unitItems(field) {
      return FIELD_UNITS[field].map(u => ({
        value: u.unit,
        text: this.$t('Pilot.QuickControl.NavProfile.' + UNIT_I18N[u.unit]),
      }))
    },
    fieldMin(field) {
      return fieldBounds(field, this.fields[field].unit).min
    },
    fieldMax(field) {
      return fieldBounds(field, this.fields[field].unit).max
    },
    // Re-décode chaque champ depuis localProfile (valeur wire → unité + affichage).
    syncFields() {
      for (const field of Object.keys(FIELD_UNITS)) {
        const { unit, display } = decodeField(field, this.localProfile?.[field])
        this.fields[field].unit = unit
        this.fields[field].display = display
      }
    },
    applyField(field) {
      if (!this.localProfile) return
      const s = this.fields[field]
      this.localProfile[field] = encodeField(field, s.unit, s.display)
      this.emit()
    },
    onFieldInput(field, val) {
      this.fields[field].display = Number(val) || 0
      this.applyField(field)
    },
    onFieldUnitChange(field, unit) {
      this.fields[field].unit = unit
      // Re-clampe la valeur affichée aux bornes de la nouvelle unité.
      const b = fieldBounds(field, unit)
      this.fields[field].display = Math.min(b.max, Math.max(b.min, this.fields[field].display))
      this.applyField(field)
    },
    // Borne un champ profondeur dans [0, Zb] (valeur fixée à la borne la plus
    // proche si hors champ).
    clampField(field) {
      if (!this.localProfile) return
      const zb = Math.abs(Number(this.localProfile.zb) || 0)
      const v = Number(this.localProfile[field])
      if (Number.isNaN(v)) return
      const clamped = Math.min(Math.max(v, 0), zb)
      if (clamped !== this.localProfile[field]) this.localProfile[field] = clamped
    },
    onDepthBlur(field) {
      this.focusedField = null
      this.clampField(field)
      this.emit()
    },
    // Sr borné à >= 1 (valeur entière) : une saisie 0 / vide / négative est
    // recalée de force à 1 au blur.
    onSrBlur() {
      if (!this.localProfile) return
      this.localProfile.sr = Math.max(1, Math.round(Number(this.localProfile.sr) || 0))
      this.emit()
    },
    onZbBlur() {
      this.focusedField = null
      // Zb se ramène à une profondeur positive…
      if (this.localProfile) {
        const z = Number(this.localProfile.zb)
        if (!Number.isNaN(z) && z < 0) this.localProfile.zb = Math.abs(z)
      }
      // …puis on re-borne Zs/Zt à la nouvelle profondeur de fond.
      this.clampField('zs')
      if (this.srVal > 1) this.clampField('zt')
      this.emit()
    },
    emit() {
      if (this.srVal === 1) {
        this.localProfile.zt = this.localProfile.zs
      }
      this.$emit('input', JSON.parse(JSON.stringify(this.localProfile)))
    },
  },
}
</script>
